import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import BridgeMonitoringRuleDialog from './BridgeMonitoringRuleDialog.vue';
import RuleHistoryDialog from './RuleHistoryDialog.vue';
export default {
  name: 'BridgeMonitoringRules',
  components: {
    BridgeMonitoringRuleDialog,
    RuleHistoryDialog
  },
  props: {
    bridgeId: {
      type: Number,
      required: true
    },
    monitoringConfigId: {
      type: Number,
      required: true
    },
    monitoringConfig: {
      type: Object,
      required: true
    },
    tenantId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      rules: [],
      ruleDialog: false,
      selectedRule: null,
      deleteDialog: false,
      ruleToDelete: null,
      resolveDialog: false,
      ruleToResolve: null,
      resolutionReason: '',
      historyDialog: false,
      selectedRuleForHistory: null
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled', 'user'])
  },
  mounted() {
    this.fetchRules();
  },
  methods: {
    async fetchRules() {
      try {
        this.rules = await ApiService.listMonitoringRules({
          bridge_id: this.bridgeId
        });
      } catch (error) {
        console.error('Error fetching rules:', error);
      }
    },
    openRuleDialog(rule = null) {
      this.selectedRule = rule;
      this.ruleDialog = true;
    },
    async saveRule(ruleData) {
      try {
        if (ruleData.id) {
          await ApiService.updateMonitoringRule(ruleData.id, ruleData);
        } else {
          await ApiService.createMonitoringRule(ruleData);
        }
        await this.fetchRules();
        this.ruleDialog = false;
        this.$snack(this.$i18n_t('Common.snacks.saveSuccess'), 'success');
        this.$emit('rule-updated');
      } catch (error) {
        this.$snack(error.message, 'error');
      }
    },
    async toggleEnabled(rule) {
      try {
        await ApiService.toggleMonitoringRule(rule.id, rule.enabled, undefined);
        this.$snack(this.$i18n_t('Common.snacks.saveSuccess'), 'success');
        this.$emit('rule-updated');
      } catch (error) {
        this.$snack(error.message, 'error');
        await this.fetchRules();
      }
    },
    async toggleSilenced(rule) {
      try {
        await ApiService.toggleMonitoringRule(rule.id, undefined, rule.silenced);
        this.$snack(this.$i18n_t('Common.snacks.saveSuccess'), 'success');
        this.$emit('rule-updated');
      } catch (error) {
        this.$snack(error.message, 'error');
        await this.fetchRules();
      }
    },
    deleteRule(rule) {
      this.ruleToDelete = rule;
      this.deleteDialog = true;
    },
    async confirmDeleteRule() {
      try {
        await ApiService.deleteMonitoringRule(this.ruleToDelete.id);
        await this.fetchRules();
        this.$snack(this.$i18n_t('Common.snacks.deleteSuccess'), 'success');
        this.$emit('rule-updated');
        this.deleteDialog = false;
        this.ruleToDelete = null;
      } catch (error) {
        this.$snack(error.message, 'error');
        this.deleteDialog = false;
      }
    },
    openResolveDialog(rule) {
      this.ruleToResolve = rule;
      this.resolutionReason = '';
      this.resolveDialog = true;
    },
    closeResolveDialog() {
      this.resolveDialog = false;
      this.ruleToResolve = null;
      this.resolutionReason = '';
    },
    async confirmResolveRule() {
      try {
        var _this$user, _this$user2;
        const userId = ((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.email) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.id) || 'unknown';
        await ApiService.resolveMonitoringRule(this.ruleToResolve.id, userId, this.resolutionReason || 'Manual resolution');
        await this.fetchRules();
        this.$snack(this.$i18n_t('Connectors.Monitoring.rules.resolveDialog.success'), 'success');
        this.$emit('rule-updated');
        this.closeResolveDialog();
      } catch (error) {
        this.$snack(error.message || this.$i18n_t('Connectors.Monitoring.rules.resolveDialog.error'), 'error');
      }
    },
    openHistoryDialog(rule) {
      this.selectedRuleForHistory = rule.id;
      this.historyDialog = true;
    },
    getStateColor(state) {
      const colors = {
        unknown: 'grey',
        ok: 'green',
        firing: 'red',
        pending: 'orange',
        flapping: 'purple'
      };
      return colors[state] || 'grey';
    },
    getSeverityColor(severity) {
      return severity === 'error' ? 'danger' : 'warning';
    }
  }
};